import { render } from "./ViewNavBar.vue?vue&type=template&id=70fecdd4&scoped=true"
import script from "./ViewNavBar.vue?vue&type=script&lang=js"
export * from "./ViewNavBar.vue?vue&type=script&lang=js"

import "./ViewNavBar.vue?vue&type=style&index=0&id=70fecdd4&lang=scss"
import "./ViewNavBar.vue?vue&type=style&index=1&id=70fecdd4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fecdd4"],['__file',"src/scripts/view/portfolio/ViewNavBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70fecdd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70fecdd4', __exports__)) {
    api.reload('70fecdd4', __exports__)
  }
  
  module.hot.accept("./ViewNavBar.vue?vue&type=template&id=70fecdd4&scoped=true", () => {
    api.rerender('70fecdd4', render)
  })

}


export default __exports__